import { render, staticRenderFns } from "./GlobalAccountSelector.vue?vue&type=template&id=37b04248&scoped=true"
import script from "./GlobalAccountSelector.vue?vue&type=script&lang=js"
export * from "./GlobalAccountSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b04248",
  null
  
)

export default component.exports